export default "__VITE_ASSET__e1dfb5eb__"